var modals = require('./modals');

var initial_version_modal = ( function ( $ ) {

    var continent_codes_to_show_for = [
        'NA',
        'SA',
    ]

    var $modal;

    var cookie_key = 'emj_site_version_initial_select';

    var latest_continent_cookie_key = 'emj_continent_cookie_key';

    var _init = function () {
        $modal = $( '#emj-initial-site-version-modal' );

        if ( _should_initialise() ) {
            _get_user_continent().then( function ( continent_code ) {
                if ( continent_codes_to_show_for.includes( continent_code ) ) {
                    _initialise_buttons();
                    _open_modal();
                }
            } ).catch( function ( error ) {
                console.log( error )
            } );
        }
    };

    var _get_user_continent = async function () {
        var continent = $.cookie( latest_continent_cookie_key );

        if ( continent && typeof continent === 'string' ) {
            return continent;
        }

        try {
            const ip_data = await $.getJSON( 'https://ipapi.co/json/' );
            const continent_code = ip_data && ip_data.continent_code ? ip_data.continent_code : null;

            if ( continent_code && typeof continent_code === 'string' ) {
                $.cookie( latest_continent_cookie_key, continent_code, { expires: 1, path: '/' } );
                
                return continent_code;
            } else {
                throw new Error( 'Continent code not found in response' );
            }
        } catch (error) {
            throw new Error( 'IP API request failed: ' + error );
        }
    }

    var _should_initialise = function () {
        return $modal.length > 0 && !_get_cookie();
    }

    var _open_modal = function () {
        $( 'body' ).addClass( 'modal-open initial-site-version-modal-open' );
        $modal.addClass( 'open' );

        _trap_focus( $modal.get( 0 ) );
        $modal.fadeIn( modals.anim_speed );
    }

    var _initialise_buttons = function () {
        $modal.find( '.emj-button' ).on( 'click', function ( e ) {
            e.preventDefault();
            _set_cookie( {
                has_set: true,
                version_selected: 'EMJ',
            } );

            window.location.href = $( this ).data( 'redirect-url' );
        });

        $modal.find( '.amj-button' ).on( 'click', function ( e ) {
            e.preventDefault();
            _set_cookie( {
                has_set: true,
                version_selected: 'AMJ',
            } );

            window.location.href = $( this ).data( 'redirect-url' );
        });
    }

    var _set_cookie = function ( values ) {
        $.cookie( cookie_key, JSON.stringify( values ), { expires: 10, path: '/' } );
    }

    var _get_cookie = function () {
        var values = $.cookie( cookie_key );

        return values ? JSON.parse( values ) : null;
    }

    var _trap_focus = function ( element ) {
        var focusableEls = element.querySelectorAll( 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])' );
        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        var KEYCODE_TAB = 9;

        element.addEventListener('keydown', function(e) {
            var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

            if ( !isTabPressed ) {
                return;
            }

            if ( e.shiftKey ) {
                if ( document.activeElement === firstFocusableEl ) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else {
                if ( document.activeElement === lastFocusableEl ) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        });
    }

    $( document ).ready( _init );

    return {};

} )( jQuery );

module.exports = initial_version_modal;